import ContactUsListing from "../contactUs/views/pages/contactUsListing.vue"
import ContactUsColumns from "../contactUs/views/pages/ContactUsColumns.vue"
import ContactUsDynamic from "./views/pages/contactUsType.vue"




export const contactUsRouters = [
  {
    path: "/contact-us",
    name: "ContactUsListing",
    component: ContactUsListing,
  },
  {
    path: "/settings/contact-us-columns",
    name: "ContactUsColumns",
    component: ContactUsColumns,
  },
{
    path: "/contact/:type",  
    name: "ContactUsDynamic",
    component: ContactUsDynamic,
  },
  
];
